import { render, staticRenderFns } from "./PerformanceMarketingBusinessDataForm.vue?vue&type=template&id=1f5a3206"
import script from "./PerformanceMarketingBusinessDataForm.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingBusinessDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports